/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import FeatherIcon from "feather-icons-react/build/FeatherIcon";
import Select from "react-select";
import TextEditor from "../../components/TextEditor";
import Header from "../../components/Header";
import Sidebar from "../../components/Sidebar";
import Breadcrumb from "../../components/Common/Breadcrumb";
import { message } from "antd";
import { fetchBlogById, updateBlog } from "../../services/blogService";
import { fetchAllUsers, fetchUserById } from "../../services/userService";
import { decrypt } from "../../utils/encryption";
import { jwtDecode } from "jwt-decode";
import { BASE_URL_IMAGE } from "../../config/api";

const Editblog = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const decryptedId = decrypt(id);

  const [title, setTitle] = useState("");
  const [status, setStatus] = useState("");
  const [tags, setTags] = useState("");
  const [description, setDescription] = useState("");
  const [image, setImage] = useState(null);
  const [previewImage, setPreviewImage] = useState("");
  const [isNewImage, setIsNewImage] = useState(false);

  const [authors, setAuthors] = useState([]);
  const [selectedAuthor, setSelectedAuthor] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [loggedInUserData, setLoggedInUserData] = useState(null);

  const blogCategories = [
    { value: 1, label: "Health Care" },
    { value: 2, label: "Child" },
    { value: 3, label: "Safety" },
  ];

  const subCategories = [
    { value: 1, label: "Health Care" },
    { value: 2, label: "Corona Virus" },
  ];

  const [selectedCategory, setSelectedCategory] = useState(blogCategories[0]);
  const [selectedSubCategory, setSelectedSubCategory] = useState(subCategories[0]);

  // ✅ Fetch logged-in user
  useEffect(() => {
    const fetchAndSetUser = async () => {
      const token = localStorage.getItem("token");
      if (token) {
        try {
          const decoded = jwtDecode(token);
          const user = await fetchUserById(decoded.id);
          setLoggedInUserData(user);
        } catch (error) {
          console.error("Error decoding token or fetching user:", error);
          localStorage.removeItem("token");
          setLoggedInUserData(null);
        }
      }
    };
    fetchAndSetUser();
  }, []);

  // ✅ Fetch blog and authors
  useEffect(() => {
    const fetchData = async () => {
      try {
        const blog = await fetchBlogById(decryptedId);
        setTitle(blog.blog_title || "");
        setStatus(blog.blog_status?.toLowerCase() || "inactive");
        setTags(blog.blog_tags || "");
        setDescription(blog.blog_description || "");

        const matchedCategory = blogCategories.find(
          (c) => c.label.toLowerCase() === blog.blog_category?.toLowerCase()
        );
        const matchedSubCategory = subCategories.find(
          (c) => c.label.toLowerCase() === blog.blog_sub_category?.toLowerCase()
        );
        setSelectedCategory(matchedCategory || blogCategories[0]);
        setSelectedSubCategory(matchedSubCategory || subCategories[0]);

        if (blog.blog_image) {
          setPreviewImage(`${BASE_URL_IMAGE}/uploads/blogImages/${blog.blog_image}`);
        }

        const users = await fetchAllUsers();
        const mappedAuthors = users.map((user) => ({
          userid: user.user_id,
          username: user.user_name,
          user_email: user.user_email,
        }));
        setAuthors(mappedAuthors);

        const matchedAuthor = mappedAuthors.find(
          (a) => a.username === blog.blog_author_name
        );
        setSelectedAuthor(matchedAuthor || null);
      } catch (err) {
        console.error("Fetch error:", err);
      }
    };
    fetchData();
  }, [decryptedId]);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(file);
      setPreviewImage(URL.createObjectURL(file));
      setIsNewImage(true);
    }
  };

  // ✅ Handle Update Blog
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!title || !selectedAuthor) {
      message.error("Please fill all required fields before submitting");
      return;
    }

    const formData = new FormData();
    formData.append("title", title);
    formData.append("author_name", selectedAuthor.username || "");
    formData.append("author_id", selectedAuthor.userid || "");
    formData.append("blog_category", selectedCategory.label);
    formData.append("blog_sub_category", selectedSubCategory.label);
    formData.append("tags", tags);
    formData.append("status", status);
    formData.append("description", description);

    // ✅ Logging data
    if (loggedInUserData?.user_email) {
      formData.append("updatedbyemail", loggedInUserData.user_email);

      let parameter;
      if (loggedInUserData?.user_role === "1") {
        parameter = "Admin";
      } else if (loggedInUserData?.user_role === "2") {
        parameter = "Department";
      } else {
        parameter = "Faculty";
      }
      formData.append("parameter", parameter);
    }

    if (image) formData.append("image", image);

    try {
      await updateBlog(decryptedId, formData);
      message.success("Blog updated successfully!");
      navigate(`/blogs`);
    } catch (error) {
      console.error("Error submitting update:", error);
      message.error(error.message || "Something went wrong!");
    }
  };

  const filteredAuthors = authors.filter(
    (author) =>
      author.username.toLowerCase().includes(searchTerm.toLowerCase()) ||
      author.user_email.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const breadcrumbItems = [
    { label: "Blogs", path: "/blogs" },
    { label: title },
  ];

  return (
    <div className="main-wrapper">
      <Header />
      <Sidebar id="menu-item11" id1="menu-items11" activeClassName="edit-blog" />
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <Breadcrumb items={breadcrumbItems} />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-body">
                  <form onSubmit={handleSubmit}>
                    <div className="row">
                      <div className="col-12 mb-2">
                        <h4 className="form-heading">Edit Blog Details</h4>
                      </div>

                      {/* Title */}
                      <div className="col-md-6">
                        <div className="form-group local-forms">
                          <label>Blog Title <span className="login-danger">*</span></label>
                          <input
                            className="form-control"
                            value={title}
                            onChange={(e) => setTitle(e.target.value)}
                            required
                          />
                        </div>
                      </div>

                      {/* Author */}
                      <div className="col-md-6">
                        <div className="form-group local-forms">
                          <label>Author <span className="login-danger">*</span></label>
                          <div className="dropdown">
                            <div
                              className="form-control d-flex align-items-center justify-content-between"
                              style={{ cursor: "pointer" }}
                              onClick={() => setIsOpen(!isOpen)}
                            >
                              {selectedAuthor ? (
                                <span>{selectedAuthor.username} - {selectedAuthor.user_email}</span>
                              ) : (
                                <span className="text-muted">Select an author</span>
                              )}
                              <i className={`bi bi-chevron-${isOpen ? "up" : "down"}`}></i>
                            </div>
                            {isOpen && (
                              <div
                                className="dropdown-menu show w-100 p-2"
                                style={{ maxHeight: "250px", overflowY: "auto" }}
                              >
                                <input
                                  type="text"
                                  className="form-control mb-2"
                                  placeholder="Search author..."
                                  value={searchTerm}
                                  onChange={(e) => setSearchTerm(e.target.value)}
                                  onClick={(e) => e.stopPropagation()}
                                />
                                {filteredAuthors.map((author) => (
                                  <button
                                    key={author.userid}
                                    type="button"
                                    className="dropdown-item"
                                    onClick={() => {
                                      setSelectedAuthor(author);
                                      setIsOpen(false);
                                      setSearchTerm("");
                                    }}
                                  >
                                    {author.username} - {author.user_email}
                                  </button>
                                ))}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>

                      {/* Category */}
                      <div className="col-md-6">
                        <div className="form-group local-forms">
                          <label>Blog Category <span className="login-danger">*</span></label>
                          <Select
                            options={blogCategories}
                            value={selectedCategory}
                            onChange={setSelectedCategory}
                          />
                        </div>
                      </div>

                      {/* Sub Category */}
                      <div className="col-md-6">
                        <div className="form-group local-forms">
                          <label>Blog Sub Category <span className="login-danger">*</span></label>
                          <Select
                            options={subCategories}
                            value={selectedSubCategory}
                            onChange={setSelectedSubCategory}
                          />
                        </div>
                      </div>

                      {/* Tags */}
                      <div className="col-md-6">
                        <div className="form-group local-forms">
                          <label>Tags <small>(comma separated)</small> <span className="login-danger">*</span></label>
                          <input
                            type="text"
                            className="form-control"
                            value={tags}
                            onChange={(e) => setTags(e.target.value)}
                          />
                        </div>
                      </div>

                      {/* Status */}
                      <div className="col-md-6">
                        <div className="form-group select-gender">
                          <label className="gen-label">Status <span className="login-danger">*</span></label>
                          <div className="form-check-inline">
                            <label className="form-check-label">
                              <input
                                type="radio"
                                name="status"
                                value="active"
                                checked={status === "active"}
                                onChange={(e) => setStatus(e.target.value)}
                                className="form-check-input"
                              /> Active
                            </label>
                          </div>
                          <div className="form-check-inline">
                            <label className="form-check-label">
                              <input
                                type="radio"
                                name="status"
                                value="inactive"
                                checked={status === "inactive"}
                                onChange={(e) => setStatus(e.target.value)}
                                className="form-check-input"
                              /> Inactive
                            </label>
                          </div>
                        </div>
                      </div>

                      {/* Description */}
                      <div className="col-12">
                        <div className="form-group summer-mail">
                          <TextEditor value={description} onChange={setDescription} />
                        </div>
                      </div>

                      {/* Image */}
                      <div className="col-12">
                        <div className="form-group local-top-form">
                          <label className="local-top mb-2">Blog Image</label>
                          <div className="row align-items-center">
                            <div className="col-md-4 mb-3 mb-md-0 text-center">
                              {previewImage ? (
                                <img
                                  src={previewImage}
                                  alt="Preview"
                                  className="rounded shadow-sm border"
                                  style={{
                                    maxWidth: "100%",
                                    height: "auto",
                                    maxHeight: "300px",
                                    objectFit: "cover",
                                  }}
                                />
                              ) : (
                                <div
                                  className="d-flex align-items-center justify-content-center bg-light border rounded"
                                  style={{ width: "100%", height: "200px" }}
                                >
                                  <span className="text-muted">No Image Selected</span>
                                </div>
                              )}
                            </div>

                            <div className="col-md-8">
                              <div className="settings-btn upload-files-avator d-flex flex-column align-items-start">
                                <input
                                  type="file"
                                  accept="image/*"
                                  name="image"
                                  id="file"
                                  onChange={handleImageChange}
                                  className="hide-input"
                                />
                                <label htmlFor="file" className="upload btn btn-primary">
                                  Choose File
                                </label>
                                {image && (
                                  <span className="mt-2 text-muted">
                                    <strong>Selected:</strong> {image.name}
                                  </span>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Submit */}
                      <div className="col-12 text-end">
                        <button type="submit" className="btn btn-primary submit-form me-2">
                          Update Blog
                        </button>
                        <Link to="/blogs" className="btn btn-quinary cancel-form">
                          Cancel
                        </Link>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Editblog;
